/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { Configuration, LogLevel } from "@azure/msal-browser";
const AUTH_AUTHORITY = process.env.REACT_APP_AUTH_AUTHORITY;
const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH_CLIENT_ID ?? "";
const REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const authConfig: Configuration = {
  auth: {
    clientId: AUTH_CLIENT_ID, // This is the ONLY mandatory field that you need to supply.
    authority: AUTH_AUTHORITY, // Replace the placeholder with your tenant subdomain
    redirectUri: REDIRECT_URI, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: "/logout", // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (level === LogLevel.Error) {
          console.error(message);
        }
      }
    }
  }
};

const apiScopes = process.env.REACT_APP_AUTH_WEBD_CORE_API_SCOPES;
const apiTokenRequest = {
  scopes: JSON.parse(apiScopes ?? "[]")
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: JSON.parse(apiScopes ?? "[]")
  // prompt: "create"
};
